import { createSelector } from "@reduxjs/toolkit";

export const singleArchivedState = (state) => state.singleArchived;

export const singleArchivedSelectors = createSelector(singleArchivedState, (state) => state);
